import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

const FAQS = [
  {
    q: "Kya aap completely custom design bana sakte hain?",
    a: "Bilkul. Har order custom hota hai — pehle hum aapke space aur pasand ke hisaab se 2D/3D PDF design banate hain, aap approve karte hain, aur tabhi carving shuru hoti hai. Aapka design, aapka size, aapka temple.",
  },
  {
    q: "Order se delivery tak kitna time lagta hai?",
    a: "Design aur size ke hisaab se aam taur par 4 se 8 hafte. Bade outdoor temples ya detailed panels mein thoda zyada samay lag sakta hai — har stage ki photos/videos aapko WhatsApp par milti rahengi.",
  },
  {
    q: "Marble ki quality ki guarantee kya hai?",
    a: "Hum sirf Grade 1 Makrana white marble (sangmarmar) use karte hain — wahi patthar jisse Taj Mahal bana hai. High calcite purity, zero water absorption, aur generation-on-generation chalne wali strength. Lab test report bhi available hai.",
  },
  {
    q: "Kya aap India ke bahar bhi deliver karte hain?",
    a: "Haan — humne 100+ countries mein export kiya hai. Har piece multi-layer foam aur heavy wooden crates mein pack hota hai, door-to-door delivery ke saath.",
  },
  {
    q: "Installation kaise hoti hai?",
    a: "Humari expert team site par aakar poori fitting karti hai — unboxing se lekar final alignment tak. 1000+ successful installations ka experience hai.",
  },
  {
    q: "Marble temple ki dekhbhal kaise karein?",
    a: "Bahut aasan — sirf soft cotton cloth aur plain water se pochhiye. Koi chemical ya acid cleaner use na karein. Makrana marble natural shine decades tak rakhta hai.",
  },
  {
    q: "Price kya hoti hai?",
    a: "Har piece custom banta hai, isliye price size, design complexity aur marble thickness par depend karti hai. Apna design ya reference photo WhatsApp karein — hum 24 hours mein best quote de denge.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-cream-200/40"
    >
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="text-[11px] tracking-[0.32em] uppercase text-gold-dark mb-4">
            — Good to Know
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl text-ink leading-[1.05]">
            Questions,
            <span className="italic gold-text"> answered.</span>
          </h2>
          <p className="text-ink-soft mt-5 text-base leading-relaxed max-w-lg mx-auto">
            Everything buyers usually ask before ordering a custom marble
            temple or sculpture.
          </p>
        </div>

        <div className="space-y-4">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className={`border bg-cream-100 transition-colors duration-300 ${
                  isOpen ? "border-gold" : "border-gold/30"
                }`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 px-6 md:px-8 py-5 text-left"
                  data-testid={`faq-question-${i}`}
                >
                  <span className="flex items-baseline gap-4">
                    <span className="font-serif text-gold-dark text-sm">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-serif text-lg md:text-xl text-ink leading-snug">
                      {f.q}
                    </span>
                  </span>
                  <Plus
                    className={`w-5 h-5 shrink-0 text-gold-dark transition-transform duration-300 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p
                        className="px-6 md:px-8 pb-6 pl-[52px] md:pl-[60px] text-ink-soft text-[15px] leading-relaxed"
                        data-testid={`faq-answer-${i}`}
                      >
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
